import React, { useState } from 'react'
import { useDebounce } from 'Hooks/useDebounce'

const CustomSearchBox = ({ placeholder, onSearch }) => {
  const debounce = useDebounce()
  const [search, setSearch] = useState('')

  const handleSearch = e => {
    const value = e.target.value
    setSearch(value)
    debounce(() => onSearch?.(value), 500)
  }

  return (
    <div className="ais-SearchBox">
      <input
        type="text"
        className="ais-SearchBox-input searchBox-sp"
        placeholder={placeholder}
        value={search}
        onChange={handleSearch}
        data-testid="input-search-products"
      />
    </div>
  )
}

export default CustomSearchBox
